// import components
import { styled, Box, BoxProps } from '@mui/material';

// import types
import { StyledActivityPlanningBoxProps } from './ActivityPlanning.types';

export const StyledActivityPlanningBox = styled(Box)<
  BoxProps & StyledActivityPlanningBoxProps
>(({ overflowX, overflowY }) => ({
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  overflowX,
  overflowY
}));
